export default Object.freeze({
  locales: ['en', 'nl', 'pl'],

  fallbackLocale: 'en'
});
